<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class="row justify-center">
  <div class="layout-card mx mt-xl col-12" [ngClass]="{'height': height}">

    <div class="inner-layout row">
      <div class="col-12" [ngClass]="{'col-md-6': icon}">
        <div class="ml-5 mt-4">
          <h2 class="step-title pt-xl ml-xl mb-5">
            {{ title }}
          </h2>
          <div class="card-body p-md">
            <ng-content select="[body]"></ng-content>
          </div>
        </div>
      </div>

      <div class="right-icon col-md-6" *ngIf="icon">
        <ng-content select="[rightIcon]"></ng-content>
      </div>
    </div>

  </div>
</div>



